import React from 'react';
import {Link} from 'react-router-dom';
import {t} from 'react-switch-lang';
import BackBtn from './img/arrow-left.svg';
import './pageHeader.scss';

const PageHeader = () => {
  return (
    <div className="page-header d-flex justify-content-between align-items-center">
      <Link to="/dashboard" className="return-btn d-flex align-items-center">
        <img src={BackBtn} alt="icon" />
        <span>
         {t('litigation.page-header-add')}
        </span>
      </Link>
    </div>
  );
};

export default PageHeader;